import { c as _c } from "react/compiler-runtime";
import { translateInline } from '@/globals/translate/translateInline';
import { delayIconTransitionHover, accordionContentPadding } from '@/uiComposites/interactive/accordion/Accordion.css';
import { AccordionItemProps } from '@/uiComposites/interactive/accordion/AccordionItem.client';
import { useAccordionItemOpened, useDispatchAccordion } from '@/uiComposites/interactive/accordion/AccordionProvider.client';
import { Collapse } from '@/uiComposites/interactive/Collapse';
import { chevronIcon } from '@/uiIcons/chevronIcon.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { icon } from '@/uiPrimitives/media/icon';
import { textBlock, textStyle } from '@/uiPrimitives/typography/text';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { useId } from 'react';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import { accordionBorder, resultAccordionStyle, width } from './legalForm.css';
import { hiddenAccessible } from '@/uiPrimitives/utility/display.css';
import { pushResultAccordionEvent } from '@/globals/analytics/events/pushDecisionToolEvent';
export const ResultAccordion = t0 => {
  const $ = _c(58);
  const {
    className,
    legalFormLabel,
    children,
    onToggle,
    score
  } = t0;
  const id = useId();
  const isOpened = useAccordionItemOpened(id);
  const dispatchAccordion = useDispatchAccordion();
  const resultScore = score < 0 ? 0 : score;
  let t1;
  if ($[0] !== className) {
    t1 = classes(className, accordionBorder);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== dispatchAccordion || $[3] !== id || $[4] !== isOpened || $[5] !== legalFormLabel || $[6] !== onToggle) {
    t2 = () => {
      const opening = !isOpened;
      dispatchAccordion({
        type: "closeAll"
      });
      dispatchAccordion({
        type: isOpened ? "close" : "open",
        id
      });
      pushResultAccordionEvent({
        resultTitle: legalFormLabel,
        opening
      });
      onToggle?.({
        id,
        opening
      });
    };
    $[2] = dispatchAccordion;
    $[3] = id;
    $[4] = isOpened;
    $[5] = legalFormLabel;
    $[6] = onToggle;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = `${Math.max(score, 0)}%`;
  let t4;
  if ($[8] !== t3) {
    t4 = assignInlineVars({
      [width]: t3
    });
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isOpened) {
    t5 = classes(shelf({
      gap: "-1 | small",
      gridTemplateColumns: "minmax(0, 1fr) auto",
      alignItems: "baseline"
    }), box({
      paddingBlock: "0 | p",
      paddingInline: "2 | h2",
      inlineSize: "100%"
    }), textStyle({
      fontWeight: isOpened ? "bold" : undefined
    }), resultAccordionStyle);
    $[10] = isOpened;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = addTestSelector("uiAccordionItem");
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = `${legalFormLabel}: ${resultScore}/100`;
  let t8;
  if ($[13] !== t7) {
    t8 = addTestSelector(t7);
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = `Score ${legalFormLabel}: ${resultScore}/100`;
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <div className={hiddenAccessible} {...t8}>{t9}</div>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = classes(textBlock({
      color: "positive:noHover"
    }));
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== legalFormLabel) {
    t12 = <h3 className={t11}>{legalFormLabel}</h3>;
    $[19] = legalFormLabel;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = classes(shelf({
      gap: "-1 | small"
    }));
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const t14 = `uiMoreInfoButton-${legalFormLabel}`;
  let t15;
  if ($[22] !== t14) {
    t15 = addTestSelector(t14);
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = textBlock({
      capSize: "-1 | small",
      color: "positive:noHover",
      fontWeight: "normal"
    });
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== isOpened) {
    t17 = isOpened ? translateInline({
      en: "Close",
      nl: "Sluiten"
    }) : translateInline({
      en: "More info",
      nl: "Meer info"
    });
    $[25] = isOpened;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t17) {
    t18 = <span className={t16}>{t17}</span>;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== isOpened) {
    t19 = classes(delayIconTransitionHover, icon({
      fill: "positive",
      icon: chevronIcon,
      adjustIcon: "rotate90deg",
      flip: isOpened ? "horizontal:hover" : "horizontalNone:hover",
      blockSize: "1ex"
    }));
    $[29] = isOpened;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t19) {
    t20 = <i className={t19} />;
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t15 || $[34] !== t18 || $[35] !== t20) {
    t21 = <div className={t13} {...t15}>{t18}{t20}</div>;
    $[33] = t15;
    $[34] = t18;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== id || $[38] !== isOpened || $[39] !== t10 || $[40] !== t12 || $[41] !== t2 || $[42] !== t21 || $[43] !== t4 || $[44] !== t5) {
    t22 = <button aria-controls={id} aria-expanded={isOpened} onClick={t2} style={t4} className={t5} {...t6}>{t10}{t12}{t21}</button>;
    $[37] = id;
    $[38] = isOpened;
    $[39] = t10;
    $[40] = t12;
    $[41] = t2;
    $[42] = t21;
    $[43] = t4;
    $[44] = t5;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  let t24;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = classes(accordionContentPadding, box({
      paddingInline: "2 | h2"
    }));
    t24 = addTestSelector("uiAccordionContent");
    $[46] = t23;
    $[47] = t24;
  } else {
    t23 = $[46];
    t24 = $[47];
  }
  let t25;
  if ($[48] !== children) {
    t25 = <div className={t23} {...t24}>{children}</div>;
    $[48] = children;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== id || $[51] !== isOpened || $[52] !== t25) {
    t26 = <Collapse id={id} isOpened={isOpened}>{t25}</Collapse>;
    $[50] = id;
    $[51] = isOpened;
    $[52] = t25;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== t1 || $[55] !== t22 || $[56] !== t26) {
    t27 = <div className={t1}>{t22}{t26}</div>;
    $[54] = t1;
    $[55] = t22;
    $[56] = t26;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  return t27;
};